import React, { Component } from "react";
import DropdownComponent from "../../components/dropdown";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from '@mui/icons-material/Edit';
import { TriggersState } from "../../store/triggers/types";
import { styled, withStyles } from "@mui/material/styles";
import { containsObject, removeDuplicateObjects } from "../../lib/common";
import "./triggers.css";
import DestinationTestResult from "./DestinationTestResult";
import {
  Alert,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@mui/material";

import { ScriptsState } from "../../store/scripts/types"
import { DestinationsState } from "../../store/destinations/types";
import { loadScriptById } from "../../store/scripts/actions"

import { QueryBuilderDnD } from '@react-querybuilder/dnd';
import * as ReactDnD from 'react-dnd';
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';
import { RuleGroupType, formatQuery } from 'react-querybuilder';
import { QueryBuilder, defaultOperators } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.css';
import { AnyAction } from "redux";
import { decodeVarbinary, urlLengthError, SAVE_FAILED_MESSAGE } from "../../lib/destinationUtils";
const styles = (theme) => ({
  checked: {
    color: "#6366F1",
    "font-weight": "600",
  },
  colorSecondary: {
    color: "#6366F1 !important",
  },
});

interface AddNewTriggerCardInterfaceProps {
  triggers: TriggersState;
  emptyTrigger: Function;
  updateTriggerField: Function;
  classes: any;
  destinations: any;
  deleteDestination: Function;
  testDestination: any;
  deleteTrigger: Function;
  saveTrigger: any;
  history?: any;
  clientId: any;
  addNewTriggerContainer: any;
  emptyDestination: any;
  updateDestinationField: any;
  edittedDestination: any;
  saveDestination: any;
  scriptId: any;
  scripts: ScriptsState;
  destination: DestinationsState;
}

let operators: Array<any> = [];
for (let i = 0; i < defaultOperators.length; i++) {
  if (defaultOperators[i].name !== 'in' && defaultOperators[i].name !== 'notIn' && defaultOperators[i].name !== 'notIn' && defaultOperators[i].name !== 'between' && defaultOperators[i].name !== 'notBetween') {
    operators.push(defaultOperators[i]);
  }
}


const parameters = [
  { name: "custom1", label: "Custom1" },
  { name: "custom2", label: "Custom2" },
  { name: "custom3", label: "Custom3" },
  { name: "custom4", label: "Custom4" },
  { name: "custom5", label: "Custom5" },
  { name: "custom6", label: "Custom6" },
  { name: "custom7", label: "Custom7" },
  { name: "custom8", label: "Custom8" },
  { name: "custom9", label: "Custom9" }
];

const options = {
  email: 'Email Address',
  hashEmail: 'Hash Email',
  timestamp: 'Timestamp of Visit',
  sourceId: 'Source ID',
  clckId: 'Click ID',
  custom1: 'Custom + 1-10',

};

const fields = [
  {
    name: "email",
    label: "Email",
    operators: operators
  },
  {
    name: "url",
    label: "URL",
    operators: operators
  },
  /*{
    name: "urlParam",
    label: "URL Parameter",
    operators: operators
  },*/
  /*{
    name: "landingDomain",
    label: "Domain",
    operators: operators
  },*/
  {
    name: "country",
    label: "Country",
    operators: operators
  },
  {
    name: "state",
    label: "State",
    operators: operators
  },
  {
    name: "device",
    label: "Device",
    operators: operators
  },
  {
    name: "zid",
    label: "zid",
    operators: operators
  },
  {
    name: "pid",
    label: "pid",
    operators: operators
  },
  {
    name: "cid",
    label: "cid",
    operators: operators
  },
  {
    label: "Custom 1",
    name: "custom1",
    operators: operators
  },
  {
    label: "Custom 2",
    name: "custom2",
    operators: operators
  },
  {
    label: "Custom 3",
    name: "custom3",
    operators: operators
  },
  {
    label: "Custom 4",
    name: "custom4",
    operators: operators
  },
  {
    label: "Custom 5",
    name: "custom5",
    operators: operators
  },
  {
    label: "Custom 6",
    name: "custom6",
    operators: operators
  },
  {
    label: "Custom 7",
    name: "custom7",
    operators: operators
  },
  {
    label: "Custom 8",
    name: "custom8",
    operators: operators
  },
  {
    label: "Custom 9",
    name: "custom9",
    operators: operators
  },
  {
    name: "page_count",
    label: "Page Count",
    operators: operators.filter((op) => ['>=', '>', '<', '<=', '='].includes(op.name)),
    inputType: 'number'
  }
  /*,
  {
    name: "timeOnPage",
    label: "Time on Page (seconds)",
    operators: defaultOperators.filter((op) => op.name === '>' || op.name === '<'),
    inputType: 'number'
  }*/
];

const condition_options = [
  { name: "Contains", value: "Contains" },
  { name: "Does not Contain", value: "Does not Contain" },
  { name: "Exactly Matches", value: "Exactly Matches" },
  { name: "Does not Exactly Match", value: "Does not Exactly Match" },
  { name: "Starts With", value: "Starts With" },
  { name: "Does not Start With", value: "Does not Start With" },
  { name: "Ends With", value: "Ends With" },
  { name: "Does not End With", value: "Does not End With" },
  { name: "Greater Than", value: "Greater Than" },
  { name: "Less Than", value: "Less Than" },
  { name: "After", value: "After" },
  { name: "Before", value: "Before" },
  { name: "Equals", value: "Equals" },
  { name: "Exists", value: "Exists" },
  { name: "Does not Exist", value: "Does not Exist" },
];

const type_options = [{ name: "webhook", value: "webhook" }];

// Product-event config (Klaviyo key, list ids, product macros, active/paused)
// lives on the Product Events screen now — deliberately not configurable here.
// decodeVarbinary is imported from the shared lib for the same reason.

const methods = [
  { name: "GET", value: "GET" },
  { name: "POST", value: "POST" },
];

const date = new Date();
var endDate = new Date();
endDate.setDate(endDate.getDate() + 30);

type MyState = {
  selectedCondition: string;
  isEdit: boolean;
  destinations: any;
  selectedDestinations: any;
  openAddNewOptionsModal: boolean;
  destSaving: boolean;
  destSaveError: string | null;
  testingTrigger: boolean;
  testResults: any;
  triggerName: string;
  scriptId: any;
  startDate: string;
  endDate: string;
  optionObject: any;
  filterOptions: any;
  dynamicData: any;
  clickedOptions: any;
};

class AddNewTriggerCard extends Component<AddNewTriggerCardInterfaceProps, MyState> {
  state: MyState = {
    // optional second annotation for better type inference
    selectedCondition: "text",
    isEdit: true,
    destinations: this.props.destinations,
    selectedDestinations: [],
    openAddNewOptionsModal: false,
    destSaving: false,
    destSaveError: null,
    testingTrigger: false,
    testResults: {},
    triggerName: "",
    scriptId: this.props.scriptId,
    startDate: date.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
    optionObject: {
      name: "",
      type: "",
      url: "",
      headers: "",
      method: "",
      emailRename: "",
    },
    filterOptions: "",
    dynamicData: {},
    clickedOptions: [],
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.editTrigger = this.editTrigger.bind(this);
    this.handleChangeDestination = this.handleChangeDestination.bind(this);
    this.handleChangeAddOption = this.handleChangeAddOption.bind(this);
    this.handleChangeFilters = this.handleChangeFilters.bind(this);
    this.inputForFilter = this.inputForFilter.bind(this);
    this.saveTriggerData = this.saveTriggerData.bind(this);
    this.addExtraFilter = this.addExtraFilter.bind(this);
    this.deleteDestination = this.deleteDestination.bind(this);
    this.testDestination = this.testDestination.bind(this);
  }

  public componentDidMount(): void {
    this.props.updateTriggerField("clientId", this.props.clientId);
    this.props.updateTriggerField("scriptId", this.props.scriptId);
  }

  public componentDidUpdate(
    prevProps: Readonly<AddNewTriggerCardInterfaceProps>,
    prevState: Readonly<MyState>,
    snapshot?: any
  ): void {
    if (this.props.destinations !== prevProps.destinations) {
      this.setState({ destinations: this.props.destinations });
    }
  }

  // Must be invoked from onMouseDown (NOT onClick): preventDefault on mousedown
  // keeps focus on the input the user was typing in; by click time the button
  // has already stolen focus and the insert silently no-ops.
  public copy(e, key) {
    e.preventDefault();
    const tag = '{{' + key + '}}';
    const el: any = document.activeElement;
  if (el && (el.nodeName === 'INPUT' || el.nodeName === 'TEXTAREA')) {
    const startPos = el.selectionStart;
    const endPos = el.selectionEnd;
    const newCursorPos = startPos + tag.length;

    el.value =
      el.value.substring(0, startPos) +
      tag +
      el.value.substring(endPos);
    el.setSelectionRange(newCursorPos, newCursorPos);

    this.handleChangeAddOption('url', el.value);
  } else {
    // nothing focused (fresh modal) — append the macro to the URL field so the
    // chip always visibly does something
    const current = (this.state.optionObject && this.state.optionObject.url) ||
      (this.props.edittedDestination && this.props.edittedDestination.url) || '';
    this.handleChangeAddOption('url', current + tag);
  }
  }

  public edit(id): void { }

  public getTrigger() {
    return 1;
  }

  private inputForFilter(condition: string) {
    let type = 'text';
    if (condition == "Greater Than" || condition == "Less Than") {
      type = 'number'
    } else if (
      condition == "After" ||
      condition == "Before" ||
      condition == "Equals"
    ) {
      type = "date";;
    } else {
      type = "text";;
    }
    return type
  }

  private setQuery(query) {
    this.handleChange("filterOptions", formatQuery(query, 'json'));
    this.setState({ filterOptions: query });
  }

  private setDynamicData(field, value) {
    var dynamic = this.state.dynamicData;
    dynamic[field] = value;
    this.handleChange("dynamicData", JSON.stringify(dynamic));
    this.setState({ dynamicData: dynamic });
  }

  private handleChange(field: string, value: any, type?: any): void {
    let modifiedValue = value;
    if (field == "condition") {
      if (value.value == "Greater Than" || value.value == "Less Than") {
        this.setState({ selectedCondition: "number" });
      } else if (
        value.value == "After" ||
        value.value == "Before" ||
        value.value == "Equals"
      ) {
        this.setState({ selectedCondition: "date" });
      } else {
        this.setState({ selectedCondition: "text" });
      }
      return;
    } else if (type == "dropdown") {
      modifiedValue = value.value;
    }
    if (field == "name") {
      this.setState({ triggerName: modifiedValue });
    }
    this.props.updateTriggerField(field, modifiedValue);
  }

  private noEndChange(e): void {
    if (this.props.triggers.editedTrigger.endDate.split('T')[0] != '2200-01-01') {
      this.handleChange('endDate', '2200-01-01');
    } else {
      this.handleChange('endDate', endDate.toISOString().split('T')[0]);
    }
  }

  public editTrigger = (event: boolean) => {
    this.setState({ isEdit: event });
  };

  private handleChangeFilters(name: string, value: any, index: number) {
    let filters: any = this.state.filterOptions.filters
    if (name == 'filter_join') {
      filters[index] = value.value || value;
    } else {
      filters[index][name] = value.value || value;
    }
    this.handleChange("filterOptions", JSON.stringify({ filters: filters }))
  }

  public handleChangeDestination = (event, type) => {
    if (event.target.value.includes("NEW")) {
      this.setState({ openAddNewOptionsModal: true, destSaving: false, destSaveError: null });
      this.handleChangeAddOption("clientId", this.props.clientId)
      // Blank the credential-bearing fields for a fresh row — redux keeps the
      // previously opened destination's values otherwise (real-key leak risk).
      this.handleChangeAddOption("apiKey", "")
      this.handleChangeAddOption("customProperties", "")
    } else {
      // A "product view" destination is consumed by srecProductViewPoller, NOT by
      // triggers. Never attach one to a trigger: it would receive recognition-fire
      // payloads and spray junk into the client's Klaviyo. It stays visible/editable
      // in the list, just not attachable.
      let selectedDestinations = removeDuplicateObjects(event.target.value, "id")
        .filter((d: any) => d && d.type !== 'product_view');
      this.setState({
        selectedDestinations: selectedDestinations,
      });
      this.props.updateTriggerField("destinationIds", selectedDestinations && selectedDestinations.length ? selectedDestinations.map((item: any) => item.id).join(',') : '');
    }
  };

  public editDestination(id, destination) {
    this.setState({ openAddNewOptionsModal: true, destSaving: false, destSaveError: null });
    let optionObject = { ...destination };
    this.setState({ optionObject: optionObject });
    this.props.updateDestinationField('clientId', destination.clientId);
    this.props.updateDestinationField('id', id);
    this.props.updateDestinationField('name', destination.name);
    this.props.updateDestinationField('type', destination.type);
    this.props.updateDestinationField('method', destination.method);
    this.props.updateDestinationField('url', destination.url);
    this.props.updateDestinationField('emailRename', destination.emailRename);
    this.props.updateDestinationField('body', destination.body);
    this.props.updateDestinationField('headers', destination.headers);
    this.props.updateDestinationField('apiKey', decodeVarbinary(destination.apiKey));
    this.props.updateDestinationField('customProperties', decodeVarbinary(destination.customProperties));

  }

  public deleteDestination() {
    this.props.deleteDestination(this.props.edittedDestination.id);
    this.setState({ openAddNewOptionsModal: false });
  }

  public testDestination() {
    this.props.testDestination(this.props.edittedDestination);
    this.setState({ testingTrigger: true });
  }

  public closeTest() {
    this.setState({ testingTrigger: false });
  }

  public handleChangeAddOption = (name, value) => {
    let optionObject = { ...this.state.optionObject };
    optionObject[name] = value;
    this.setState({ optionObject: optionObject });
    this.props.updateDestinationField(name, value);
  };


  public saveOption = (e?) => {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.state.destSaving) return;
    let dest = this.props.edittedDestination;
    if (dest.type !== 'product_view') {
      // No UI sets apiKey for non-product_view types — anything present is
      // stale redux from a previously opened Klaviyo-direct row. Without this
      // strip, a client's real key would get copied onto ordinary webhook
      // rows on save (the '[object Object]' junk on old rows came from this
      // exact leak path, pre-decode).
      dest = { ...dest, apiKey: '' };
      this.props.updateDestinationField('apiKey', '');
    }
    // The database rejects URLs over the column size; say so instead of failing.
    const tooLong = urlLengthError(dest.url);
    if (tooLong) {
      this.setState({ destSaveError: tooLong });
      return;
    }
    // Close only once the save is confirmed; on failure keep the modal open with
    // the typed values (a failed save used to close the modal and lose them).
    this.setState({ destSaving: true, destSaveError: null });
    Promise.resolve(this.props.saveDestination(dest, this.props.history))
      .then(() => this.setState({ destSaving: false, openAddNewOptionsModal: false }))
      .catch(() => this.setState({ destSaving: false, destSaveError: SAVE_FAILED_MESSAGE }));
  };

  public saveTriggerData() {
    this.editTrigger(false);
    this.props.addNewTriggerContainer(false)
    this.props.saveTrigger(this.props.triggers.editedTrigger, this.props.history);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  private addExtraFilter() {
    let filters: any = [...this.state.filterOptions.filters]
    filters.push(...['AND', {
      "field": "",
      "operator": "",
      "value": ""
      ,
    }]);
    this.setState({ filterOptions: { filters: filters } })
  }

  public render(): JSX.Element {
    const state = this.state;
    const props = this.props;
    const { classes } = this.props;
    let filterOptions = state.filterOptions.filters;

    return (
      <>
        {state.openAddNewOptionsModal ? (
          <Dialog
            fullWidth
            aria-labelledby="customized-dialog-title"
            open={state.openAddNewOptionsModal}
            id="customize-dialog-box"
          >
            <div className="customized-dialog-header">
              <DialogTitle id="customized-dialog-title">
                {this.props.edittedDestination.id ? "Edit Option" : "Add New Option"}
              </DialogTitle>
              <div>
                {this.props.edittedDestination.id ?
                  <button id="test-btn" onClick={() => this.testDestination()}>Test</button>
                  : <></>}
                {this.props.edittedDestination.id ?
                  <button onClick={() => this.deleteDestination()}>Delete</button>
                  : <></>}
              </div>
            </div>
            <DialogContent dividers>
              {state.destSaveError ? (
                <Alert severity="error" className="mb-4">{state.destSaveError}</Alert>
              ) : null}
              {state.testingTrigger ? (
                <Dialog
                  fullWidth
                  aria-labelledby="customized-dialog-title"
                  className="customized-dialog-box"
                  open={state.testingTrigger}
                >
                  <DestinationTestResult result={this.props.destination.testResults} />
                  <section className="customized-dialog-box__button"><button onClick={() => this.closeTest()}>Done</button></section>
                </Dialog>) : <></>}
              <form
                // className={classes.root}
                noValidate
                autoComplete="off"
                onSubmit={(event) => this.saveOption(event)}
              >
                <div className="flexBox">
                  <div id="w50" className="mb-4">
                    <label className="field_label">Name</label>
                    <input
                      name="name"
                      required
                      type="text"
                      value={props.edittedDestination.name || ''}
                      //value="305-000-0000"
                      onChange={(event) =>
                        this.handleChangeAddOption("name", event.target.value)
                      }
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Type</label>
                    <div className="select_multi">
                      <Select
                        name="type"
                        value={props.edittedDestination.type || ''}
                        onChange={(event) =>
                          this.handleChangeAddOption("type", event.target.value)
                        }
                        variant="outlined"
                      >
                        {type_options.map((option) => (
                          <MenuItem key={option.name} value={option.value}>
                            <ListItemText primary={option.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div id="w100" className="mb-4">
                    <label className="field_label">URL</label>
                    <input
                      name="url"
                      required
                      type="text"
                      value={this.state.optionObject.url || ''}
                      //value="305-000-0000"
                      onChange={(event) => {
                        this.handleChangeAddOption("url", event.target.value)
                      }
                      }
                      disabled={!state.isEdit}
                    />
                    <div className="options_buttons_area">
                      {/* type="button" is REQUIRED: these live inside the modal <form>,
                          and an HTML button defaults to type="submit" — every chip click
                          was silently submitting the form and CREATING an unnamed
                          destination row (found 2026-07-24: 5 blank rows on Test1234,
                          plus older strays on real clients). */}
                      {Object.entries(options).map(([k, label]) => (
                        <button key={k} type="button" className="options_button" title={'{{' + k + '}}'} onMouseDown={e => {
                          const updatedClickedOptions = [...this.state.clickedOptions, label];

                          this.setState({ clickedOptions: updatedClickedOptions });
                          this.copy(e, k);
                        }}>
                          {label}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Headers</label>
                    <input
                      name="headers"
                      required
                      type="text"
                      value={props.edittedDestination.headers || ''}
                      //value="305-000-0000"
                      onChange={(event) =>
                        this.handleChangeAddOption(
                          "headers",
                          event.target.value
                        )
                      }
                      disabled={!state.isEdit}
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Method</label>
                    <div className="select_multi">
                      <Select
                        name="method"
                        value={props.edittedDestination.method || 'GET'}
                        onChange={(event) =>
                          this.handleChangeAddOption(
                            "method",
                            event.target.value
                          )
                        }
                        variant="outlined"
                      >
                        {methods.map((option) => (
                          <MenuItem key={option.name} value={option.value}>
                            <ListItemText primary={option.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Body</label>
                    <input
                      name="body"
                      required
                      type="text"
                      value={props.edittedDestination.body || ''}
                      //value="305-000-0000"
                      onChange={(event) =>
                        this.handleChangeAddOption("body", event.target.value)
                      }
                    />
                  </div>
                  <div id="w50" className="mb-4">
                    <label className="field_label">Custom Properties</label>
                    <input
                      name="customProperties"
                      required
                      type="text"
                      value={props.edittedDestination.customProperties}
                      onChange={(event) =>
                        this.handleChangeAddOption("customProperties", event.target.value)
                      }
                    />
                  </div>
                </div>
              </form>
            </DialogContent>
            <DialogActions>
              <button
                className="button secondary mr-3"
                onClick={() => this.setState({ openAddNewOptionsModal: false, destSaveError: null })}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="button accent"
                disabled={state.destSaving}
                onClick={(event) => this.saveOption(event)}
              >
                {state.destSaving ? "Saving..." : "Save Changes"}
              </button>
            </DialogActions>
          </Dialog>
        ) : null}
        <div className="trigger_card">
          <div className="d-flex trigger_card__heading mb-4">
            {state.isEdit ? (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">Name</label>
                <input
                  required
                  type="text"
                  value={props.triggers.editedTrigger.name}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("name", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : (
              <h3>{state.triggerName || "Trigger Name Example"}</h3>
            )}

            {state.isEdit ? (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">Start Date</label>
                <input
                  required
                  type="date"
                  value={props.triggers.editedTrigger.startDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("startDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">Start Date</label>
                <input
                  required
                  type="date"
                  value={props.triggers.editedTrigger.startDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("startDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            )}

            {state.isEdit ? (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">No End?</label>
                <input
                  required
                  type="checkbox"
                  checked={props.triggers.editedTrigger.endDate.split('T')[0] == '2200-01-01'}
                  //value="305-000-0000"
                  onChange={(e) =>
                    this.noEndChange("noEnd")
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : (
              <div className="d-flex">
                <label className="field_label mr-4 mb-0">No End?</label>
                <input
                  required
                  type="checkbox"
                  checked={props.triggers.editedTrigger.endDate.split('T')[0] == '2200-01-01'}
                  //value="305-000-0000"
                  onChange={(e) =>
                    this.noEndChange("noEnd")
                  }
                  disabled={!state.isEdit}
                />
              </div>
            )}

            {state.isEdit && props.triggers.editedTrigger.endDate.split('T')[0] != '2200-01-01' ? (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">End Date</label>
                <input
                  required
                  type="date"
                  value={props.triggers.editedTrigger.endDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("endDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : props.triggers.editedTrigger.endDate.split('T')[0] != '2200-01-01' ? (
              <div id="w33" className="d-flex">
                <label className="field_label mr-4 mb-0">End Date</label>
                <input
                  required
                  type="date"
                  value={props.triggers.editedTrigger.endDate.split('T')[0]}
                  //value="305-000-0000"
                  onChange={(event) =>
                    this.handleChange("endDate", event.target.value)
                  }
                  disabled={!state.isEdit}
                />
              </div>
            ) : ''}

            {state.isEdit ? (
              <div>
                <button
                  className="button secondary mr-3"
                  onClick={() => { this.editTrigger(false); this.props.addNewTriggerContainer(false) }}
                >
                  Cancel
                </button>
                <button
                  className="button accent"
                  onClick={() => this.saveTriggerData()}
                >
                  Save
                </button>
              </div>
            ) : (
              <button
                className="button secondary"
                onClick={() => {
                  this.editTrigger(true);
                }}
              >
                Edit Trigger
              </button>
            )}
          </div>

          {
            (
              <div>
                <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
                  <QueryBuilder fields={fields} query={this.state.filterOptions} onQueryChange={q => this.setQuery(q)} />
                </QueryBuilderDnD>
                <div className="pt15 time_on_page">
                  <div id="w50" className="d-flex">
                    <label className="field_label mr-4 mb-0">Time On Page In Seconds</label>
                    <input
                      required
                      type="number"
                      value={this.state.dynamicData.timeOnPage}
                      //value="305-000-0000"
                      onChange={(event) =>
                        this.setDynamicData("timeOnPage", event.target.value)
                      }
                      disabled={!state.isEdit}
                    />
                  </div>
                </div>
                <div className="pt15">
                  <label
                    id="destination-multi-label"
                    className="field_label"
                  >
                    Destination
                  </label>
                  <div className="select_multi">
                    <Select
                      labelId="destination-multi-label"
                      id="destination-multi"
                      multiple
                      value={state.selectedDestinations || []}
                      onChange={this.handleChangeDestination}
                      // renderValue={(selected) => (selected as string[]).join(', ')}
                      renderValue={(selected) =>
                        Array.from((selected) as any)
                          .map((item: any) => item.name)
                          .join(", ")
                      }
                      variant="outlined"
                      disabled={!state.isEdit}
                      name="destination-multi"
                    >
                      <MenuItem
                        value="NEW"
                        // classes={{ root: classes.checked }}
                        onClick={(e) => { this.props.emptyDestination() }}
                      >
                        <AddIcon
                          fontSize="small"
                          style={{
                            marginRight: "1rem",
                            marginLeft: "0.5rem",
                          }}
                        />
                        Add New
                      </MenuItem>
                      {state.destinations.map((option) => (
                        <MenuItem key={option.id} value={option}>
                          <Checkbox
                            // classes={{
                            //   checked: classes.checked,
                            //   colorSecondary: classes.colorSecondary,
                            // }}

                            checked={containsObject(
                              option,
                              state.selectedDestinations
                            )}
                          />
                          <ListItemText primary={option.name} />
                          <ListItemIcon>
                            <EditIcon onClick={(e) => { this.editDestination(option.id, option) }} />
                          </ListItemIcon>
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            )
          }

        </div>
      </>
    );
  }
}

//export default withStyles(styles, { withTheme: true })(AddNewTriggerCard);
export default styled(AddNewTriggerCard)(({ theme }) => (styles));
